<ng-container #viewContainer>
  <button class="color-swatch-flyout-container" data-test="color-swatch-flyout-container" #menuTrigger (click)="openMenu()">
    <!-- Display custom icon instead of swatch -->
    <capra-icon
      *ngIf="customIcon"
      class="custom-icon"
      data-test="icon-container"
      [icon]="customIcon"
    ></capra-icon>

    <!-- Display swatch if a custom icon is not provided -->
    <div
      *ngIf="!customIcon"
      class="swatch"
      [class.active]="isMenuOpen$ | async"
      data-test="swatch-container"
      [style.background]="activeColor"
    ></div>
  </button>
</ng-container>
